import { Currency } from "appworks/services/currency/currency";
import { SoundManager } from "appworks/services/sound/sound-manager";
import { LocalStorage } from "appworks/services/storage/local-storage";
import { Transaction } from "appworks/services/transaction/transaction";
import { Translations } from "appworks/services/translations/translations";
import { Signal } from "signals";
import { Autoplay } from "slotworks/services/autoplay/autoplay";
import { SlotBet } from "slotworks/services/bet/slot-bet";
import { JurisdictionService } from "slotworks/services/jurisdiction/jurisdiction-service";
import { Service } from "./service";
import { Settings } from "./settings/settings-service";

export class Services {
    public static BetType = SlotBet;
    public static StorageType = LocalStorage;
    public static SoundManagerType = SoundManager;
    public static CurrencyType = Currency;
    public static TranslationsType = Translations;
    public static TransactionType = Transaction;
    public static AutoplayType = Autoplay;
    public static SettingsType = Settings;
    public static JurisdictionType = JurisdictionService;

    public static bet: SlotBet;
    public static storage: LocalStorage;
    public static sound: SoundManager;
    public static currency: Currency;
    public static translations: Translations;
    public static transaction: Transaction;
    public static autoplay: Autoplay;
    public static settings: Settings;
    public static jurisdiction: JurisdictionService;

    public static init() {
        this.bet = new Services.BetType();
        this.storage = new Services.StorageType();
        this.sound = new Services.SoundManagerType();
        this.currency = new Services.CurrencyType();
        this.translations = new Services.TranslationsType();
        this.transaction = new Services.TransactionType();
        this.autoplay = new Services.AutoplayType();
        this.settings = new Services.SettingsType();
        this.jurisdiction = new Services.JurisdictionType();

        const services: Service[] = [
            this.bet,
            this.storage,
            this.sound,
            this.currency,
            this.translations,
            this.transaction,
            this.autoplay,
            this.settings,
            this.jurisdiction
        ];

        services.forEach((service) => service.init());
    }
}
